// Function to convert uploaded file to base64
export const loadFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener("abort", (e) =>
      reject(`File upload aborted: ${e}`),
    );
    reader.addEventListener("error", (e) => reject(`File upload error: ${e}`));
    reader.addEventListener("load", () => {
      resolve({
        name: file.name,
        size: file.size,
        type: file.type,
        encoded: reader.result, // This will be the data:image/... string
      });
    });

    reader.readAsDataURL(file); // This creates the base64 data URL
  });
};
